module.exports = __webpack_public_path__ + "img/grey-podcasts-2.efcc7b6b.png";